<template>
	<div id="app">
		<div id="view">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	import {
		setTimeout
	} from 'core-js/library/web'
	export default {
		name: 'app',
		components: {
		},
		data() {
			return {
				timer:null,//定义一个计时器
				fullscreenLoading: false
			}
		},
		beforeDestroy() {
			if(this.timer){
				clearInterval(this.timer)
			}
		},
		mounted() {
			// this.timer = setInterval(() => {
			// 	const loading = this.$loading({
			// 		lock: true,
			// 		text: '切换中...',
			// 		spinner: 'el-icon-loading',
			// 		background: 'rgba(0, 0, 0, 0.7)'
			// 	});
			// 	setTimeout(() => {
			// 		if (this.$route.path != "/clear") {
			// 			this.$router.push({
			// 				path: "/clear"
			// 			})
			// 		} else {
			// 			this.$router.push({
			// 				path: "/"
			// 			})
			// 		}
			// 		loading.close();
			// 	}, 1000);
			// }, 50000)
		},
	}
</script>

<style>
	#app {
		box-sizing: border-box;
	}
</style>
